import { Config } from '@packages/shared/interfaces';
import { HttpClientBuilder } from '../HttpClientBuilder';

export const createExpertsDealerHttpClient = (config: Config) => {
  return new HttpClientBuilder(config.services.expertsDealerUrl).addRequestId().getResult();
};
